import React, { Component } from 'react';
import styled from 'styled-components';
import moment from 'moment';

import API from './API';
import u from './Utilities';

import OverlayWindow from './OverlayWindow';
import Button from './Button';
import SessionList from './SessionList';
import SessionListItem from './SessionListItem';
import TopBar from './TopBar';
import SuperButton from './SuperButton';
import Spinner from './Spinner';
import TinySpinner from './TinySpinner';
import TextFill from './TextFill';
import CustomCalendar from './CustomCalendar';
import Counter from './Counter';

import './static/css/hw-widget.scss';
import './static/css/fa.css';

import ImageBackground1 from './static/img/opening-page-background.png';
import ImageBackground2 from './static/img/generic-background.png';

import ImageLogo from './static/img/logo-full-color.png';

const StyledApp = styled.div``

class App extends React.Component {
    constructor(props) {
        super(props);

        this.defaultState = {
            // flags
            isOverlayOpen: false,
            isPayLoading: false,
            isAvailabilityLoading: false,
            isLoading: true,

            currentScreen: 'init',

            resources: null, // [{},...]
            bookings: [],
            projects: [],
            events: [],
            availability: [],

            selectedProject: null, // {}
            selectedAvailability: null, // {}
            selectedResource: null, // "" = resourceID
            filteredVouchers: null, // []
            guestVouchers: null, // []

            guestCount: 0, // int

            name: "",
            email: "",

            error: null, // string
            wpUserState: null, // {}
            bookingPrecheck: null, // {}
            bookingResponse: null, // {}

            bookingMode: null, // string
            reactError: null,
            wpError: null, // null or error
        }

        this.state = {
            ...this.defaultState
        }

        // for reference only
        this.screenList = [
            'init',
            'session',
            'booking',
            'info',
            'thankyou'
        ];

        // for reference only
        this.bookingModeList = [
            'credits',
            'voucher'
        ]

        this.handleEventClick = this.handleEventClick.bind(this);

        window.openHoopwerxBooker = this.open.bind(this);
    }

    load() {
        this.setState(this.defaultState);
        let wpUserState = u.getWPUserState();

        this.setState({
            wpUserState: wpUserState,
            isLoggedIn: wpUserState.id != null ? true : false
        });

        API.getTimekitBookings().then(
            (success) => {
                // if nonce is invalid, it will shortcircuit here
                if(success.code == 'rest_cookie_invalid_nonce') {
                    this.setState({
                        wpError: success.code
                    });
                    return;
                }

                // setting users active bookings
                let bookings = success.bookings.data.filter((b) => {
                    return b.completed == false && b.event != null;
                });

                this.setState({
                    bookings: bookings,
                    currentPlan: success.current_plan
                });
            },
            (error) => {
                console.warn(error);
            }
        ).finally(() => {
            this.setState({isLoading: false});
        });

        // grabbing project cost map
        API.getProjectMap().then(
            (success) => {
                this.setState({
                    projectMap: success.project_map
                });
            }
        );
        
        // grabbing available projects
        API.getTimekitProjects().then(
            (success) => {
                let projects = {};
    
                for(var p of success.data) {
                    projects[p.id] = {
                        ...p,
                    };
                }
    
                this.setState({
                    projects: projects
                });
            }
        );
    }

    open() {
        this.load();
        this.setState({isOverlayOpen: true});
    }

    componentDidMount() {
    }

    componentDidCatch(error, info) {
        this.setState({
            reactError: {
                error: error,
                info: info
            }
        });
        console.log("The booker has run into an error. See details.", error, info);
    }

    superReset() {
        this.reset();
        window.location.reload();
    }

    reset(autoOpen = false) {
        this.setState((state) => ({
            ...this.defaultState,
            isOverlayOpen: autoOpen
        }));
        this.componentDidMount();
    }

    goToScreen(s) {
        this.setState({currentScreen: s});
    }

    selectProject(i, resource) {
        this.setState({
            selectedProject: i,
            isAvailabilityLoading: true,
            selectedResource: resource
        });
        API.getTimekitAvailability({projectID: i.id, resourceID: resource.id}).then(
            (success) => {
                let availableEvents = success.data.map((e) => {
                    return {
                        ...e,
                        backgroundColor: '#2ecc71',
                        borderColor: '#2ecc71',
                        title: 'Open'
                    }
                });
                this.setState({ availability: availableEvents });
            }
        ).finally(() => {
            this.setState({isAvailabilityLoading: false});
        })
        this.goToScreen('booking');
    }

    updateResources(i, resources) {
        this.setState({
            selectedProject: i,
            isAvailabilityLoading: true,
            resources: resources
        });
        this.goToScreen('resources');
    }

    checkBooking(event) {
        this.setState({
            bookingPrecheck: null,
            bookingMode: null,
            error: null
        });
        API.postBookingCheck({
            name: this.state.name,
            email: this.state.email,
            start: event.start,
            end: event.end,
            resourceID: this.state.selectedResource.id,
            projectID: this.state.selectedProject.id,
            userID: parseInt(this.state.wpUserState.id)
        }).then(
            (success) => {
                let filteredVouchers = success.vouchers ? Object.entries(success.vouchers).filter((v) => {
                    return v[1].project_id == this.state.selectedProject.id;
                }) : [];

                let guestVouchers = success.vouchers ? Object.entries(success.vouchers).filter((v) => {
                    return v[1].type == 'guest';
                }) : [];

                this.setState((state) => ({
                    ...state,
                    bookingPrecheck: success,
                    filteredVouchers: filteredVouchers,
                    guestVouchers: guestVouchers,
                    bookingMode: ''
                }))
            }
        )
    }

    raiseError(e) {
        this.setState({error: e});
    }

    clearError() {
        this.setState({error: null});
    }

    handleClose() {
        this.setState({isOverlayOpen: false});
        this.reset();
    }

    handleEventClick(e) {
        this.setState((state) => ({
            selectedAvailability: e,
            name: state.wpUserState.display_name,
            email: state.wpUserState.email
        }));

        this.checkBooking(e);
        this.goToScreen('info');
    }

    handleOnChange(e, field) {
        this.setState({[field]: e.target.value });
    }
    
    handlePayClick() {
        this.clearError();
        this.setState({isPayLoading: true});

        if(this.state.name.length >= 3 && this.state.email.length > 11) {
            API.postBooking({
                name: this.state.name,
                email: this.state.email,
                start: this.state.selectedAvailability.start,
                end: this.state.selectedAvailability.end,
                resourceID: this.state.selectedAvailability.resources[0].id,
                projectID: this.state.selectedProject.id,
                userID: parseInt(this.state.wpUserState.id),
                use: this.state.bookingMode,
                guestCount: this.state.guestCount
            }).then(
                (success) => {
                    if(success.confirmed) {
                        this.setState({
                            bookingResponse: success.response
                        });
                        this.goToScreen('thankyou')
                    } else if(success.status == 'not_enough_credits') {
                        this.setState({
                            bookingResponse: success.response,
                            error: 'You do not have sufficient credits to book this event.'
                        });
                    } else {
                        this.setState({
                            bookingResponse: success.response,
                            error: <div>An error has occured. <pre>{JSON.stringify(success, null, 2)}</pre></div>
                        });
                    }
                }
            ).finally(() => {
                this.setState({isPayLoading: false});
            });
        } else {
            this.raiseError("Name or e-mail address is invalid. Please check your info and try again.");
        }
    }

    handleResourceSelect(rid) {
        this.setState({
            isAvailabilityLoading: true,
            selectedResource: this.state.resources[rid]
        });
        API.getTimekitAvailability({projectID: this.state.selectedProject.id, resourceID: this.state.resources[rid].id}).then(
            (success) => {
                let availableEvents = success.data.map((e) => {
                    return {
                        ...e,
                        backgroundColor: '#2ecc71',
                        borderColor: '#2ecc71',
                        title: 'Open'
                    }
                });
                this.setState({ availability: availableEvents });
            }
        ).finally(() => {
            this.setState({isAvailabilityLoading: false});
        })
        this.goToScreen('booking');
    }

    renderCalendar() {
        if(!this.state.isAvailabilityLoading) {
            return (
                <CustomCalendar events={this.state.availability} onEventClick={this.handleEventClick} bookings={this.state.bookings} projectMap={this.state.projectMap} plan={this.state.currentPlan}/>
            );
        }
        return (
            <TextFill spinner>Getting available slots...</TextFill>
        )
    }

    renderBookingPrecheck() {
        let renderInsufficientCredits = () => {
            if(this.state.bookingPrecheck.balance_after < 0) {
                return (
                    <div>
                        <div style={{color: '#e74c3c'}}>
                            <i>You do not have sufficient credits to book this event.</i>
                            <br/>
                            <i>Upgrade your membership or <a href="/shop/extra-credit/" target="_blank" rel="nofollow noopener noreferrer">buy more credits here</a>.</i>
                        </div>
                    </div>
                )
            }
        }
        let renderHoopOnTrainer = () => {
            if(this.state.bookingPrecheck.requires_hoop == true) {
                if(this.state.bookingPrecheck.hoop_available) {
                    let c = [];
                    for(let h of this.state.bookingPrecheck.hoop_availability) {
                        c.push(
                            <li>
                                {h.resources[0].name}
                            </li>
                        );
                    }

                    return (
                        <React.Fragment>
                            <div className="hw-widget__separator"></div>
                            <div style={{color: '#7ed6df'}}>
                                <p>A hoop lane is included and required to complete the selected event.</p>
                                <br/>
                                <p>Book this session now to save this slot.</p>
                                <ul>
                                    {c}
                                </ul>
                            </div>
                        </React.Fragment>
                    );
                } else {
                    return (
                        <React.Fragment>
                            <div className="hw-widget__separator"></div>
                            <div style={{color: '#7ed6df'}}>
                                <p>A hoop lane is included and required to complete the selected event.</p>
                                <br/>
                                <p style={{color: '#eb4d4b'}}><i>There are no open hoop lanes for this time, please try a different time slot.</i></p>
                            </div>
                        </React.Fragment>
                    );
                }
            }
        }
        if(this.state.bookingPrecheck) {
            if(this.state.bookingMode == 'credit') {
                return (
                    <React.Fragment>
                        <div className="hw-widget__separator"></div>
                        <div className="no-pad">
                            <p><b>Current balance: </b>{u.pluralize(this.state.bookingPrecheck.balance_before, "credit", "credits")}</p>
                            <p><b>Balance after booking: </b>{u.pluralize(this.state.bookingPrecheck.balance_after, "credit", "credits")}</p>
                            {renderInsufficientCredits()}
                            {renderHoopOnTrainer()}
                        </div>
                        <div className="hw-widget__separator"></div>
                        <p><b>Add a guest</b> <a href="/shop/session-add-guest/" target="_blank" rel="noopener noreferrer">Buy guest passes</a> • <a href="#" onClick={() => this.checkBooking(this.state.selectedAvailability)}>Refresh</a></p>
                        <div className="no-pad c">
                            <Counter limit={u.clamp(this.state.guestVouchers.length, 0, 2)} onChange={(v) => this.handleOnChange({target: {value: v}}, 'guestCount')}/>
                            <p>{this.state.guestCount} of {u.pluralize(this.state.guestVouchers.length, 'guest', 'guests')}</p>
                        </div>
                    </React.Fragment>
                );
            } else if(this.state.bookingMode == 'combo') {
                return (
                    <React.Fragment>
                        <div className="hw-widget__separator"></div>
                        <div className="no-pad">
                            <p><b>Current balance: </b>{u.pluralize(this.state.bookingPrecheck.balance_before, "credit", "credits")}</p>
                            <p><b>Balance after booking: </b>{u.pluralize(this.state.bookingPrecheck.balance_after, "credit", "credits")}</p>
                            {renderInsufficientCredits()}
                            {renderHoopOnTrainer()}
                        </div>
                    </React.Fragment>
                );
            }
        } else {
            return (
                <React.Fragment/>
            )
        }
    }

    renderBookingMode() {
        if(this.state.bookingPrecheck) {
            let choiceCredit = () => {
                if(this.state.bookingPrecheck.cost > 0 && this.state.bookingPrecheck.type != 'combo') {
                    return (
                        <div onClick={() => this.setState({bookingMode: 'credit'})} className={"hw-widget__pay-options__item" + (this.state.bookingMode == 'credit' ? ' hw-widget__pay-options__item--selected' : '')}>
                            <div className="hw-widget__pay-options__item__check-box">
                                <i class="fas fa-check"></i>
                            </div>
                            <div className="hw-widget__pay-options__item__details">
                                <h1>{this.state.bookingPrecheck.cost}</h1>
                                <p>{u.pluralize(this.state.bookingPrecheck.cost, "credit", "credits", false)}</p>
                            </div>
                        </div>
                    )
                }
                // } else {
                //     return (
                //         <div className="hw-widget__pay-options__item hw-widget__pay-options__item--disabled" style={{textAlign: "center"}}>
                //             <p><i>This session cannot be booked with credits.</i></p>
                //         </div>
                //     )
                // }
            }

            let choiceVoucher = () => {
                if(this.state.filteredVouchers && this.state.filteredVouchers.length > 0 && this.state.bookingPrecheck.type != 'combo') {
                    return (
                        <div onClick={() => this.setState({bookingMode: 'voucher'})} className={"hw-widget__pay-options__item" + (this.state.bookingMode == 'voucher' ? ' hw-widget__pay-options__item--selected' : '')}>
                            <div className="hw-widget__pay-options__item__check-box">
                                <i class="fas fa-check"></i>
                            </div>
                            <div className="hw-widget__pay-options__item__details">
                                <h1>1</h1>
                                <p>voucher</p>
                            </div>
                        </div>
                    )
                } else {

                }
            }

            let choiceCombo = () => {
                if(this.state.bookingPrecheck.type == 'combo') {
                    if(this.state.filteredVouchers && this.state.filteredVouchers.length > 0) {
                        if(this.state.bookingPrecheck.balance_after < 0) {
                            return (
                                <div className="hw-widget__message">
                                    <p>You have a voucher available, however, you do not have enough credits to book this session.</p>
                                    <p>You will need to purchase {u.pluralize(Math.abs(this.state.bookingPrecheck.balance_after), 'credit', 'credits')} in order to book.</p>
                                    {/* <p><a href="/shop/session-book-trainer/" target="_blank" rel="noopener noreferrer">Purchase a trainer voucher here.</a></p> */}
                                    <p><a href="/shop/extra-credit/" target="_blank" rel="noopener noreferrer">Purchase more credits</a></p>
                                    <p><a id="R" href="#R" onClick={() => this.checkBooking(this.state.selectedAvailability)}>Refresh</a></p>
                                </div>
                            );
                        }
                        return (
                            <div style={{width: "100%"}} onClick={() => this.setState({bookingMode: 'combo'})} className={"hw-widget__pay-options__item" + (this.state.bookingMode == 'combo' ? ' hw-widget__pay-options__item--selected' : '')}>
                                <div className="hw-widget__pay-options__item__check-box">
                                    <i class="fas fa-check"></i>
                                </div>
                                <div className="hw-widget__pay-options__item__details">
                                    <div className="c c--ac">
                                        <div>
                                            <h1>1</h1>
                                            <p>credit</p>
                                        </div>
                                        <div style={{margin: "0px 20px"}}>
                                            <h1>+</h1>
                                        </div>
                                        <div>
                                            <h1>1</h1>
                                            <p>voucher</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    } else {
                        return (
                            <div className="hw-widget__message">
                                <p>You do not have a trainer voucher available to book with.</p>
                                <p><a href="/shop/session-book-trainer/" target="_blank" rel="noopener noreferrer">Purchase a trainer voucher</a></p>
                                <p><a id="R" href="#R" onClick={() => this.checkBooking(this.state.selectedAvailability)}>Refresh</a></p>
                            </div>
                        );
                    }
                }
            }

            return (
                <React.Fragment>
                    <p>Select a payment method below.</p>
                    <div className="hw-widget__separator"></div>
                    <p><b>Pay using</b></p>
                    <div className="hw-widget__pay-options">
                        {choiceCredit()}
                        {choiceVoucher()}
                        {choiceCombo()}
                    </div>
                </React.Fragment>
            )
        } else {
            return (
                <Spinner />
            )
        }
    }

    renderProjects() {
        if(Object.keys(this.state.projects).length > 0) {
            let c = [];

            for(let [k, p] of Object.entries(this.state.projects)) {
                let props = {
                    projectID: p.id,
                    title: p.booking.what,
                    key: p.id,
                    onSelect: (resource) => this.selectProject(p, resource),
                    onSelectMultiresource: (resources) => this.updateResources(p, resources),
                    resources: p.resources
                }
                c.push(
                    <SessionListItem {...props} />
                );
            }

            return (
                <SessionList>
                    {c}
                </SessionList>
            )
        }
        return (
            <Spinner />
        )
    }

    renderError() {
        if(this.state.error) {
            return (
                <div className="hw-widget__error">
                    {this.state.error}
                </div>
            )
        } else {
            return (
                <div></div>
            )
        }
    }

    renderReactError() {
        if(this.state.reactError) {
            return (
                <div className="hw-widget__error">
                    {JSON.stringify(this.state.reactError, null, 2)}
                </div>
            )
        } else {
            return (
                <div></div>
            )
        }
    }

    renderUserInfo() {
        return (
            <div className="hw-widget__sidebar__bottom no-pad">
                <h4>{this.state.wpUserState.display_name}</h4>
                <p>{u.pluralize(this.state.wpUserState.credits, "credit", "credits")}</p>
            </div>
        )
    }

    renderThankYouDetails() {
        let startDate = moment(this.state.bookingResponse.data.start).format('LL');
        let startTime = moment(this.state.bookingResponse.data.start).format('LT');
        let endDate = moment(this.state.bookingResponse.data.end).format('LL');
        let endTime = moment(this.state.bookingResponse.data.end).format('LT');

        let relativeTime = moment(this.state.bookingResponse.data.start).fromNow();
        return (
            <div className="hw-widget__thank-you__details">
                <h3>Event</h3>
                <p>{this.state.bookingResponse.data.what}</p>
                <p>{this.state.bookingResponse.data.where}</p>

                <div className="hw-widget__separator"></div>

                <h3>Your booking is on</h3>
                <p className="hw-widget__highlight">{String(startDate) == String(endDate) ? startDate : `${startDate} - ${endDate}`}</p>
                <p className="hw-widget__highlight">{startTime} - {endTime}</p>

                <div className="hw-widget__separator"></div>
                
                <h4>Your booking will be</h4>
                <p>{relativeTime}</p>
            </div>
        );
    }

    renderCredits() {
        if(this.state.bookingPrecheck) {
            return (
                <div>
                    <h3>Your Credits</h3>
                    <p><b className="hw-widget__highlight">{this.state.bookingPrecheck.balance_before}</b> {u.pluralize(this.state.bookingPrecheck.balance_before, 'credit', 'credits', false)}</p>
                </div>
            )
        }
    }

    renderVouchers() {
        if(this.state.bookingPrecheck) {
            let c = [];
            let trainerCount = 0;
            let guestCount = 0;
            if(this.state.bookingPrecheck.vouchers != null) {
                for(let v of this.state.bookingPrecheck.vouchers) {
                    if(v.type == 'booking') {
                        // if()
                        trainerCount++;
                    } else if(v.type == 'guest') {
                        guestCount++;
                    }
                }
            }
            return (
                <div>
                    <h3>Your Passes</h3>
                    <p className={trainerCount > 0 ? '' : 'hw-widget__grey-out'}>
                        <b className="hw-widget__highlight">{trainerCount}x</b> trainer {u.pluralize(trainerCount, 'pass', 'passes', false)}
                        <a style={{textAlign: "right"}} href="#" target="_blank" rel="noopener noreferrer"><i class="fa-solid fa-circle-plus"></i></a>
                    </p>
                    <p className={guestCount > 0 ? '' : 'hw-widget__grey-out'}>
                        <b className="hw-widget__highlight">{guestCount}x</b> guest {u.pluralize(guestCount, 'pass', 'passes', false)}
                        <a style={{textAlign: "right"}} href="#" target="_blank" rel="noopener noreferrer"><i class="fa-solid fa-circle-plus"></i></a>
                    </p>
                </div>
            )
        } else {
            return (
                <Spinner/>
            )
        }
    }

    renderPayButton() {
        let c = <React.Fragment>Book</React.Fragment>;

        if(this.state.bookingMode == 'credit') {
            c = <React.Fragment>Use {this.state.bookingPrecheck ? u.pluralize(this.state.bookingPrecheck.cost, "credit", "credits") : <TinySpinner noMargin/>} and book</React.Fragment>
        } else if(this.state.bookingMode == 'voucher') {
            c = <React.Fragment>Use 1 voucher and book</React.Fragment>
        }

        let dCheck = (this.state.bookingPrecheck && this.state.bookingPrecheck.balance_after >= 0) && this.state.bookingMode;
        dCheck = this.state.bookingMode == 'combo' && !this.state.bookingPrecheck.hoop_available ? false : dCheck;
        
        return (
            <Button onClick={() => this.handlePayClick()} disabled={!dCheck} busy={this.state.isPayLoading}>
                {c}
            </Button>
        )
    }

    renderResources() {
        if(this.state.resources && Object.keys(this.state.resources).length > 0) {
            if(Object.keys(this.state.resources).length != 1) {
                let c = [];
                for(var [key, r] of Object.entries(this.state.resources)) {
                    const cKey = key;
                    c.push(
                        <div className="hw-widget__session-list__resource" onClick={() => this.handleResourceSelect(cKey)}>
                            <div className="hw-widget__session-list__icon" style={{backgroundImage: `url(${r.image})`}}></div>
                            <p>{r.name}</p>
                        </div>
                    )
                }
                return c;
            }
        }
    }

    renderScreen() {
        let currentScreen = this.state.currentScreen;

        if(currentScreen == 'init') {
            if(this.state.isLoading) {
                return (
                    <div className="hw-widget hw-widget--top-open">
                        <div className="hw-widget__top">
                            <div className="hw-widget__close-button" onClick={() => this.handleClose()}></div>
                            <div className="hw-widget__banner" style={{backgroundImage: `url(${ImageBackground1})`}}>
                                <div className="c" style={{filter: 'drop-shadow(0px 2px 8px rgba(0, 0, 0, 0.9))', textAlign: 'left', flexDirection: 'column', justifyContent: 'space-around', height: '100%', padding: '0px 40px'}}>
                                    <div>
                                        <TextFill spinner>Getting sessions and bookings...</TextFill>
                                    </div>
                                </div>
                            </div>
                            <div className="hw-widget__sidebar">
                                
                            </div>
                        </div>
                    </div>
                )
            }
            if(this.state.wpError) {
                return (
                    <div className="hw-widget hw-widget--top-open">
                        <div className="hw-widget__top">
                            <div className="hw-widget__close-button" onClick={() => this.handleClose()}></div>
                            <div className="hw-widget__banner" style={{backgroundImage: `url(${ImageBackground1})`}}>
                                <div className="c" style={{filter: 'drop-shadow(0px 2px 8px rgba(0, 0, 0, 0.9))', textAlign: 'left', flexDirection: 'column', justifyContent: 'space-around', height: '100%', padding: '0px 40px'}}>
                                    <div>
                                        <img src={ImageLogo} alt="" />
                                        <h1>An error has occured.</h1>
                                        <p>Error code: {this.state.wpError}</p>
                                        <a onClick={() => this.superReset()} className="hw-widget__button">
                                            Reload
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="hw-widget__sidebar">
                                
                            </div>
                        </div>
                    </div>
                )
            }
            if(this.state.wpUserState && (this.state.wpUserState.id == 0 || this.state.wpUserState.id == null)) {
                return (
                    <div className="hw-widget hw-widget--top-open">
                        <div className="hw-widget__top">
                            <div className="hw-widget__close-button" onClick={() => this.handleClose()}></div>
                            <div className="hw-widget__banner" style={{backgroundImage: `url(${ImageBackground1})`}}>
                                <div className="c" style={{filter: 'drop-shadow(0px 2px 8px rgba(0, 0, 0, 0.9))', textAlign: 'left', flexDirection: 'column', justifyContent: 'space-around', height: '100%', padding: '0px 40px'}}>
                                    <div>
                                        <img src={ImageLogo} alt="" />
                                        <h1>Sign up for a membership today!</h1>
                                        <p>Join us at HoopWERX and you'll get access to our facilities, professional basketball coaches, training equipment, time booking, and much more!</p>
                                        <a href="https://www.hoopwerx.com/join-now" className="hw-widget__button">
                                            View Memberships and Details
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="hw-widget__sidebar">
                                
                            </div>
                        </div>
                    </div>
                )
            }
            return (
                <div className="hw-widget hw-widget--top-open">
                    <div className="hw-widget__top">
                        <div className="hw-widget__close-button" onClick={() => this.handleClose()}></div>
                        <div className="hw-widget__banner" style={{backgroundImage: `url(${ImageBackground1})`}}>
                            <div className="c" style={{filter: 'drop-shadow(0px 2px 8px rgba(0, 0, 0, 0.9))', textAlign: 'center', flexDirection: 'column', justifyContent: 'space-around', height: '100%', padding: '0px 40px'}}>
                                <div>
                                    <img src={ImageLogo} alt="" style={{marginBottom: "60px"}}/>
                                    <h1 style={{marginBottom: "20px"}}>Session Booker</h1>
                                    <SuperButton onClick={() => this.goToScreen('session')}>Get started</SuperButton>
                                </div>
                            </div>
                        </div>
                        <div className="hw-widget__sidebar">
                            
                        </div>
                    </div>
                </div>
            )
        } else if(currentScreen == 'session') {
            return (
                <div className="hw-widget">
                    <div className="hw-widget__content" style={{backgroundImage: `url(${ImageBackground2})`}}>
                        <TopBar anchor title="Select a session" onClose={() => this.handleClose()} onBack={() => this.goToScreen('init')}/>
                        <div className="hw-widget__separator" style={{margin: "10px 0px 8px 0px"}}></div>
                        {this.renderProjects()}
                        {this.renderUserInfo()}
                    </div>
                </div>
            );
        } else if(currentScreen == 'resources') {
            return (
                <div className="hw-widget">
                    <div className="hw-widget__content" style={{backgroundImage: `url(${ImageBackground2})`}}>
                        <TopBar anchor title="Select a session" onBack={() => this.goToScreen('session')}/>
                        <div className="no-pad" style={{padding: "8px 10px 0px 10px", boxSizing: "border-box"}}>
                            <h3>Select a resource</h3>
                            <div className="hw-widget__separator" style={{margin: "10px 0px 8px 0px"}}></div>
                            <div className="hw-widget__session-list__item hw-widget__session-list--multi">
                                {this.renderResources()}
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else if(currentScreen == 'booking') {
            return (
                <div className="hw-widget">
                    <div className="hw-widget__content" style={{backgroundImage: `url(${ImageBackground2})`}}>
                        <TopBar anchor title="Select an open time slot" onBack={() => this.goToScreen('session')}/>
                        <p className="ta-center">Use the calendar below and scroll down to select a time slot.</p>
                        <div className="hw-widget__separator"></div>
                        {this.renderCalendar()}
                    </div>
                </div>
            );
        } else if(currentScreen == 'info') {
            let resource = this.state.selectedResource;
            let startDate = moment(this.state.selectedAvailability.start).format('LL');
            let startTime = moment(this.state.selectedAvailability.start).format('LT');
            let endDate = moment(this.state.selectedAvailability.end).format('LL');
            let endTime = moment(this.state.selectedAvailability.end).format('LT');

            let relativeTime = moment(this.state.selectedAvailability.start).fromNow();
            return (
                <div className="hw-widget">
                    <div className="hw-widget__content" style={{backgroundImage: `url(${ImageBackground2})`}}>
                        <TopBar anchor title="Enter your info and book" onBack={() => this.goToScreen('booking')}/>

                        <div className="hw-widget__separator"></div>

                        <div className="c" style={{alignItems: "baseline"}}>
                            <div style={{width: "40%", marginRight: "10px"}}>
                                <div className="hw-widget__big-booking">
                                    <h3>Your booking is</h3>
                                    <h3 className="hw-widget__highlight">{startTime} - {endTime}</h3>
                                    <p className="hw-widget__highlight">{String(startDate) == String(endDate) ? startDate : `${startDate} - ${endDate}`}</p>
                                    <div className="hw-widget__separator"></div>
                                    <p><b>Event: </b>{this.state.selectedProject.booking.what}</p>
                                    <p><b>Location: </b>{this.state.selectedProject.booking.where}</p>

                                    <p><b>Your booking will be </b><span className="hw-widget__highlight">{relativeTime}</span></p>
                                    <div className="hw-widget__big-resource">
                                        <div className="hw-widget__big-resource__details">
                                            <p>{resource.name}</p>
                                        </div>
                                    </div> 
                                    <div className="hw-widget__separator"></div>
                                    {this.renderCredits()}
                                    <div className="hw-widget__separator"></div>
                                    {this.renderVouchers()}
                                </div>
                            </div>
                            <div style={{width: "60%"}}>
                                {this.renderBookingMode()}
                                {this.renderBookingPrecheck()}

                                <div className="hw-widget__separator"></div>

                                {this.renderError()}
                                {this.renderPayButton()}
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else if(currentScreen == 'thankyou') {
            return (
                <div className="hw-widget">
                    <div className="hw-widget__content" style={{backgroundImage: `url(${ImageBackground2})`}}>
                        <div className="c" style={{filter: 'drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.9))', flexDirection: 'column', justifyContent: 'space-around', height: '100%', padding: '0px 30px'}}>
                            <div className="hw-widget__thank-you">
                                <div className="hw-widget__thank-you__top">
                                    <div className="hw-widget__thank-you__graphic">
                                        <div className="hw-widget__icon-sphere hw-widget__icon-sphere--in" style={{marginBottom: "20px"}}>
                                            <i className="fas fa-check"></i>
                                        </div>
                                        <h1>Thank you!</h1>
                                        <h4>You are now booked!</h4>
                                    </div>
                                    {this.renderThankYouDetails()}
                                </div>
                                <div className="hw-widget__thank-you__bottom">
                                    <p>An e-mail has been sent out to <b>{this.state.email}</b> with your booking info and instructions.</p>
                                    <p>
                                        <SuperButton onClick={() => this.superReset()}>Finish</SuperButton>
                                    </p>
                                    <p style={{marginTop: "30px"}}>
                                        <p><i>Want to add a trainer or another session?</i></p>
                                        <Button onClick={() => this.reset(true)}>Add another session</Button>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div>no screen</div>
            );
        }
    }

    getNextWholeHourDate(date) {
        let newDate = new Date(date);
        newDate.setHours(date.getHours() + Math.ceil(date.getMinutes() / 60));
        newDate.setMinutes(0, 0, 0);

        return newDate;
    }

    render() {
        let linkStyle = {
            padding: '12px 22px',
            backgroundColor: 'rgb(255, 131, 60)',
            color: 'white',
            fontWeight: '800',
            textDecoration: 'none',
        }

        return (
            <StyledApp>
                <a style={linkStyle} href="#" id="HW-WIDGET-LINK" className="hw-widget__link" onClick={() => this.open()}>Book a session</a>
                <OverlayWindow onClose={() => this.setState({isOverlayOpen: false})} isOpen={this.state.isOverlayOpen}>
                    {this.renderScreen()}
                </OverlayWindow>
            </StyledApp>
        );
        return this.renderScreen();
    }
}
 
export default App;